import { useCallback, useEffect, useRef, useState } from "react";
import "./ImageSlider.css";

const ImageSlider = ({ slides, parentWidth }) => {
    const timerRef = useRef(null);

    const [currentIndex, setCurrentIndex] = useState(0);

    const goToPrevious = () => {
        const isFirstSlide =  currentIndex === 0
        const newIndex = isFirstSlide ? slides.length - 1 : currentIndex - 1;
        setCurrentIndex(newIndex);
    };

    const goToNext = useCallback(() => {
        const isLastSlide = currentIndex === slides.length - 1
        const newIndex = isLastSlide ? 0 : currentIndex + 1;
        setCurrentIndex(newIndex);
    }, [currentIndex, slides]);

    const goToSlide = (slideIndex) => {
        setCurrentIndex(slideIndex);
    };

    const getSlideStylesWithBackground = (slideIndex) => ({
        height: "100%",
        borderRadius: "0.5em",
        backgroundPosition: "center",
        backgroundSize: "cover",
        backgroundImage: `url(${slides[slideIndex].url})`,
        width: `${parentWidth}px`,
    });

    const getSlideContainerStylesWithWitdh = () => ({
        display: "flex",
        height: "100%",
        transition: "transform ease-out 0.4s",
        width: parentWidth * slides.length,
        transform: `translateX(${-(currentIndex * parentWidth)}px)`,
    });

    useEffect(() => {
        if(timerRef.current){
            clearTimeout(timerRef.current)
        }

        timerRef.current = setTimeout(() => {
            goToNext();
        }, 15000);

        return () => clearTimeout(timerRef.current);
    }, [goToNext]);

    return (
        <div className="sliderStyles">
            <div>
                <div className="leftArrowStyles" onClick={goToPrevious}>〈</div>
                <div className="RightArrowStyles" onClick={goToNext}>〉</div>
            </div>

            <div>
                <p>
                    <var className="description-image-font">
                        {slides[currentIndex].description}
                    </var>
                </p>
            </div>
            
            <div className="slidesContainerOverflowStyles">
                <div style={getSlideContainerStylesWithWitdh()}>
                    {slides.map((_, slideIndex) => (
                    <div style={getSlideStylesWithBackground(slideIndex)} key={slideIndex}>
                        </div>
                    ))}
                </div>
            </div>

            <div className="dotsContainerStyles">
                {slides.map((slide, slideIndex) => (
                    <div className="dotStyle" key={slideIndex} onClick={() => goToSlide(slideIndex)}>
                        •
                    </div>
                ))}
            </div>
            
        </div>
    )
};

export default ImageSlider;